;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const automationsCreateButtonTarget = tourSelector(
	TOUR_TARGETS.automationsCreateButton,
);
const automationCreateTriggersTarget = tourSelector(
	TOUR_TARGETS.automationCreateTriggers,
);
const automationCreateNameTarget = tourSelector(
	TOUR_TARGETS.automationCreateName,
);
const automationCreateNameCompleteTarget = tourSelector(
	TOUR_TARGETS.automationCreateNameComplete,
);
const automationSourceStepTarget = tourSelector(
	TOUR_TARGETS.automationSourceStep,
);
const automationOperationStepTarget = tourSelector(
	TOUR_TARGETS.automationOperationStep,
);
const automationDestinationStepTarget = tourSelector(
	TOUR_TARGETS.automationDestinationStep,
);
const automationPublishButtonTarget = tourSelector(
	TOUR_TARGETS.automationPublishButton,
);
const automationSaveDraftButtonTarget = tourSelector(
	TOUR_TARGETS.automationSaveDraftButton,
);

export const createAutomationTour = defineTour({
	buildSteps: () => [
		tourStep({
			content: "Start building a new data automation for your workspace.",
			data: {
				advanceOn: "target-click",
				watchTargetClick: {
					selector: automationsCreateButtonTarget,
					stepIndex: 1,
				},
			},
			placement: "bottom",
			target: automationsCreateButtonTarget,
			title: "New automation",
		}),
		tourStep({
			content: "Choose when this automation runs — on a schedule or on demand.",
			data: {
				advanceOn: "target-click",
			},
			effect: "openCreateAutomation",
			placement: "bottom",
			spotlightPadding: 8,
			target: automationCreateTriggersTarget,
			title: "When to run",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Give your automation a clear name so your team can find it later.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: automationCreateNameCompleteTarget,
			},
			effect: "openCreateAutomation",
			placement: "bottom",
			spotlightPadding: 8,
			target: automationCreateNameTarget,
			title: "Name your automation",
			waitForTarget: true,
		}),
		tourStep({
			content: "Pick a connected data source to pull from.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: automationOperationStepTarget,
			},
			effect: "openCreateAutomation",
			placement: "top",
			scrollBefore: automationSourceStepTarget,
			spotlightPadding: 12,
			target: automationSourceStepTarget,
			title: "Data source",
			waitForTarget: true,
		}),
		tourStep({
			content: "Choose the operation that transforms your data.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: automationDestinationStepTarget,
				skipWhenTargetHidden: true,
			},
			effect: "openCreateAutomation",
			placement: "top",
			spotlightPadding: 12,
			target: automationOperationStepTarget,
			title: "Operation",
			waitForTarget: true,
		}),
		tourStep({
			content: "Select where the results should be delivered.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: automationPublishButtonTarget,
				skipWhenTargetHidden: true,
			},
			effect: "openCreateAutomation",
			placement: "top",
			spotlightPadding: 12,
			target: automationDestinationStepTarget,
			title: "Destination",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Publish when you are ready, or save as a draft to finish later.",
			data: {
				completeWhenTargetsClicked: [
					automationPublishButtonTarget,
					automationSaveDraftButtonTarget,
				],
				skipWhenTargetHidden: true,
			},
			effect: "openCreateAutomation",
			placement: "top",
			spotlightPadding: 8,
			target: automationPublishButtonTarget,
			title: "Publish",
			waitForTarget: true,
		}),
	],
	catalog: { lockedLabel: "Upgrade to unlock" },
	category: TourCategory.automations,
	description:
		"Build data pipelines that sync, transform, and deliver insights on a schedule.",
	eligibility: { requiresFullProductAccess: true },
	id: "create-automation",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/automations`,
	},
	tags: ["automation", "etl", "pipeline", "workflow"],
	title: "Create an automation",
});
